import { render } from "./PayrollSyncUsers.vue?vue&type=template&id=64532776&scoped=true&lang=pug"
import script from "./PayrollSyncUsers.vue?vue&type=script&lang=js"
export * from "./PayrollSyncUsers.vue?vue&type=script&lang=js"

import "./PayrollSyncUsers.vue?vue&type=style&index=0&id=64532776&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64532776"]])

export default __exports__